import { render, staticRenderFns } from "./BytesHistogram.vue?vue&type=template&id=7c6eda12"
import script from "./BytesHistogram.vue?vue&type=script&lang=js"
export * from "./BytesHistogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports